/** Legacy client document sync (Firestore-style listeners) — disabled; Clerk + Postgres API only. */

export function isClientDocumentSyncEnabled(): boolean {
  return false;
}
